import React from 'react';
import styled from 'styled-components';

import { Template } from '@xing-com/crate-lebenslauf-components';
import type { TemplateConfig } from '@xing-com/crate-lebenslauf-components';
import type { TemplateTraditionalProps } from '@xing-com/crate-lebenslauf-xinglets/src';

import {
  Header,
  useAboutMe,
  usePersonalData,
  useProfessionalInformation,
  useEducation,
  useSkills,
} from './sections';

const translations = {
  EN: require('../i18n/locales/en.js'),
  DE: require('../i18n/locales/de.js'),
};

const TraditionalTheme = styled.div`
  font-family: 'Open Sans';
`;

const traditionalConfig: TemplateConfig = {
  columnSize: ['35%', '65%'],
  pageMargin: {
    top: 119,
    left: 42,
    right: 42,
    bottom: 25,
  },
};

export const Traditional: React.FC<TemplateTraditionalProps> = ({
  className,
  ...props
}) => {
  const aboutMe = useAboutMe();
  const personalData = usePersonalData();
  const professionalInformation = useProfessionalInformation();
  const education = useEducation();
  const skills = useSkills();

  const unitsByColumn = React.useMemo(
    () => [
      [...aboutMe, ...skills, ...education],
      [...personalData, ...professionalInformation],
    ],
    [aboutMe, personalData, professionalInformation, education, skills]
  );

  return (
    <TraditionalTheme className={className}>
      <Template
        translations={translations}
        unitsByColumn={unitsByColumn}
        templateConfig={traditionalConfig}
        Header={Header}
        {...props}
      />
    </TraditionalTheme>
  );
};
